module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "statistics_2"
  }, [_c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [_c('span', {
    staticClass: "ttText"
  }, [_vm._v("播放量统计")]), _vm._v(" "), _c('div', {
    staticClass: "timeArea"
  }, [_c('span', [_vm._v("分项：")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.typeChange
    },
    model: {
      value: (_vm.params.type),
      callback: function($$v) {
        _vm.$set(_vm.params, "type", $$v)
      },
      expression: "params.type"
    }
  }, _vm._l((_vm.typeSelect), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value,
        "disabled": item.disabled
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "timeArea"
  }, [_c('span', [_vm._v("分页：")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.ssPostAct
    },
    model: {
      value: (_vm.params.no),
      callback: function($$v) {
        _vm.$set(_vm.params, "no", $$v)
      },
      expression: "params.no"
    }
  }, _vm._l((_vm.pageNumCage), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value,
        "disabled": item.disabled
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "timeArea"
  }, [_c('span', [_vm._v("数据库：")]), _vm._v(" "), _c('el-select', {
    staticClass: "sp-select",
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.ssPostAct
    },
    model: {
      value: (_vm.params.code),
      callback: function($$v) {
        _vm.$set(_vm.params, "code", $$v)
      },
      expression: "params.code"
    }
  }, _vm._l((_vm.labCage), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]), _vm._v(" "), [_c('v-chart', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "height": "600px",
      "width": "100%"
    },
    attrs: {
      "options": _vm.sortbar
    }
  })]], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-6c6addc2"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/playSort.vue
// module id = 1517
// module chunks = 1